import { useMemo } from "react";
import { useSelector } from "react-redux";

/**
 * Use Asset-type Identifiers Hook
 * Identifier to identify identifer1, identifer2 and identifer3
 * should be taken from typeIdentifiers as this may change for every org
 */
export default (typeId) => {
    const { typesList } = useSelector((state) => state);

    const next = useMemo(() => {
        if (typeId) {
            const { typeIdentifiers } = typesList;
            const identiferIds = typeIdentifiers.data
                .filter((item) => item.typeId === typeId)
                .map((item) => item.identifierId);

            return typeIdentifiers.data
                .filter(
                    (item) =>
                        identiferIds.includes(item.identifierId) &&
                        item.typeId === typeId
                )
                .reduce(
                    (aggregate, item) => ({
                        ...aggregate,
                        [`identifier${item.identifierId}`]: item.value
                    }),
                    {}
                );
        }
        return {};
    }, [typeId, typesList]);

    return next;
};
